$(document).ready(function()
{
    if (jQuery('.sort-table').length)
    {
        jQuery('.sort-table').DataTable(
        {
            "searching": false,
            "info": false,
            "paging": false,
            "autoWidth": false,
            "order": [[ 0, "asc" ]]
        });
    }
    if (jQuery('.sort-table-desc').length)
    {
        jQuery('.sort-table-desc').DataTable(
        {
            "searching": false,
            "info": false,
            "paging": false,
            "autoWidth": false,
            "order": [[ 0, "desc" ]]
        });
    }

    if (jQuery('.sort-table-date').length)
    {
        jQuery('.sort-table-date').DataTable(
        {
            "searching": false,
            "info": false,
            "paging": false,
            "order": [[ 3, "desc" ]]
        });

    }
    if (jQuery('#rates-table').length)
    {
        jQuery('#rates-table').DataTable(
        {
            "searching": false,
            "info": false,
            "paging": false,
            "autoWidth": false,
            "order": [[ 2, "desc" ]]
        });
    }
});
//$.fn.dataTableExt.sErrMode = 'throw';